export function errorHandler(appsignal, app) {
    var _a;
    var version = (_a = app === null || app === void 0 ? void 0 : app.version) !== null && _a !== void 0 ? _a : "";
    return function (error, vm, info) {
        var componentName = vm.$vnode
            ? vm.$vnode.componentOptions.tag
            : vm.$options.name || vm.$options.__name;
        var span = appsignal.createSpan();
        span
            .setAction(componentName || "[unknown Vue component]")
            .setTags({ framework: "Vue", info: info, version: version })
            .setError(error);
        appsignal.send(span);
        if (typeof console !== "undefined" && typeof console.error === "function") {
            console.error(error);
        }
    };
}
//# sourceMappingURL=index.js.map